import './assets/tailwind.css';
// src/main.js
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // Zorg dat dit pad correct is

createApp(App).use(router).mount("#app");

